import React, {FC} from "react"
import {WellnessMedia} from "@irati/types"
import {Wrapper, AuthorImage} from "./styled"

interface Props {
  media: WellnessMedia
}

const LiveVideoPlayerPlaceholder: FC<Props> = ({media}) => {
  return (
    <Wrapper thumbnail={media.thumbnail} marginTop={5}>
      {media.author?.image && <AuthorImage authorImage={media.author.image} />}
    </Wrapper>
  )
}

export default LiveVideoPlayerPlaceholder
